module.exports = __webpack_public_path__ + "img/Volkswagen_logo_300x300.e978cbf4.png";